import { render, staticRenderFns } from "./ExhibitionOverview.vue?vue&type=template&id=dbe0f934&"
import script from "./ExhibitionOverview.vue?vue&type=script&lang=js&"
export * from "./ExhibitionOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports